export const AnalyticModalEventNames = {
  SNOOZE_MORTGAGE_CASE: 'snooze_mortgage_case',
  OPEN_MORTGAGE_CASE: 'open_mortgage_case',
  CLOSE_MORTGAGE_CASE: 'close_mortgage_case',
  OPEN_HELP_CASE: 'open_help_case',
  CLOSE_HELP_CASE: 'close_help_case',
  CLOSE_SMART_SEARCH_CASE: 'close_smart_search_case',
  ADD_IRREGULAR_PAYMENT: 'add_irregular_payment',
  DELETE_IRREGULAR_PAYMENT: 'delete_irregular_payment',
  PAID_OFF_MORTGAGE: 'paid_off_mortgage',
  START_REMORTGAGE: 'start_remortgage',
  ADD_PORTFOLIO_ITEM: 'add_portfolio_item',
  ADD_PORTFOLIO_FOLDER: 'add_portfolio_folder',
  DELETE_PORTFOLIO_FOLDER: 'delete_portfolio_folder',
  SMART_SEARCH_CASE_DETAIL: 'smart_search_case_detail',
  CHANGE_PORTFOLIO_FOLDER_NAME: 'change_portfolio_folder_name',
  MOVE_PROPERTY_INTO_FOLDER: 'move_property_into_folder',
  ADJUST_PROPERTY_VALUATION: 'adjust_property_valuation',
  DELETE_PROPERTY_VALUE: 'delete_property_value',
  CHANGE_PROPERTY_NAME: 'change_property_name',
  SOLD_PROPERTY: 'sold_property',
  ADD_SMART_SEARCH: 'add_smart_search',
  DELETE_SMART_SEARCH: 'delete_smart_search',
  ADD_DOCUMENT: 'add_document',
  SELECT_LENDER: 'select_lender',
  ADDRESS_DETAILS: 'address_details',
  MORTGAGE_PART: 'mortgage_part',
  INFO_DIALOG: 'info_dialog',
  UPDATE_SMART_SEARCH: 'update_smart_search',
};
